export default {
  AD: {
    monthly: '9€',
    yearly: '72€',
    lifetime: '145€',
    yearlyMonthly: '6€',
  },
  ES: {
    monthly: '9€',
    yearly: '72€',
    lifetime: '145€',
    yearlyMonthly: '6€',
  },
  IT: {
    monthly: '9€',
    yearly: '72€',
    lifetime: '145€',
    yearlyMonthly: '6€',
  },
  PT: {
    monthly: '9€',
    yearly: '72€',
    lifetime: '145€',
    yearlyMonthly: '6€',
  },
  FR: {
    monthly: '12€',
    yearly: '96€',
    lifetime: '195€',
    yearlyMonthly: '8€',
  },
  DE: {
    monthly: '12€',
    yearly: '96€',
    lifetime: '195€',
    yearlyMonthly: '8€',
  },
  MX: {
    monthly: 'MX$145',
    yearly: 'MX$1200',
    lifetime: 'MX$2350',
    yearlyMonthly: 'MX$100',
  },
  CL: {
    monthly: 'CLP 8,000',
    yearly: 'CLP 60,000',
    lifetime: 'CLP 125,000',
    yearlyMonthly: 'CLP 5,000',
  },
  PE: {
    monthly: 'PEN 28',
    yearly: 'PEN 240',
    lifetime: 'PEN 450',
    yearlyMonthly: 'PEN 20',
  },
  AR: {
    monthly: '$6',
    yearly: '$48',
    lifetime: '$100',
    yearlyMonthly: '$4',
  },
  US: {
    monthly: '$15',
    yearly: '$120',
    lifetime: '$234',
    yearlyMonthly: '$10',
  },
};
